import {
  CLUB_ADD,
  CLUB_ADMIN,
  CLUB_LIST,
  CLUB_UPDATE,
} from "../../../api/endPoint";
import { updateClubWebsite as updateClubWebsiteApi } from "../../../api/clubApi";
import instance from "../../../helpers/axios";

const listClubs = (params = {}) => instance.get(CLUB_LIST, { params });

const getClubAdmin = (id) => instance.get(`${CLUB_ADMIN}${id}`);

const createClub = (body) => instance.post(CLUB_ADD, body);

const updateClub = (id, body) => instance.put(`${CLUB_UPDATE}${id}`, body);

const updateClubWebsite = (id, body) => updateClubWebsiteApi(id, body);

const clubService = {
  listClubs,
  getClubAdmin,
  createClub,
  updateClub,
  updateClubWebsite,
};

export default clubService;
